import { render, staticRenderFns } from "./EntradaResumenItem.vue?vue&type=template&id=39d2fd08"
import script from "./EntradaResumenItem.vue?vue&type=script&setup=true&lang=js"
export * from "./EntradaResumenItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports